import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ProfileGuard } from '@guards/profile/profile.guard';
import { ClientResolver, ProfileResolver } from 'core/resolvers';
import { PaymentResolver } from './resolvers/payment.resolver';
import { CreditsOrderComponent } from './credits-order/credits-order.component';

const paymentsRoutes: Routes = [
  {
    path: 'payments',
    title: 'parentPayments',
    resolve: {},
    children: [
      {
        path: 'order-credits',
        title: 'paymentsOrderCredits',
        component: CreditsOrderComponent,
        canActivate: [ProfileGuard],
        data: { action: 'credits.order' },
        resolve: {
          client: ClientResolver,
          user: ProfileResolver,
          orderOptions: PaymentResolver
        }
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(paymentsRoutes)],
  exports: [RouterModule]
})
export class PaymentsRoutingModule {}
